import { useState } from "react";

import { useAuth0 } from "@auth0/auth0-react";
import { CircleUserRoundIcon, CreditCardIcon, LogOutIcon, Menu, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { ROUTES } from "utils/constants";

import Button from "components/Button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "components/DropdownMenu";

export default function MainMenu() {
  const { t } = useTranslation();
  const { logout } = useAuth0();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const menuItems = [
    {
      label: t("menu.myProfile"),
      link: ROUTES.PROFILE,
      icon: CircleUserRoundIcon,
    },
    {
      label: t("menu.subscriptions"),
      link: ROUTES.SUBSCRIPTION,
      icon: CreditCardIcon,
    },
    {
      label: t("menu.logout"),
      link: "#",
      icon: LogOutIcon,
      onClick: () => logout({ logoutParams: { returnTo: window.location.origin } }),
    },
  ];

  return (
    <>
      <div
        className={`md:hidden fixed top-16 left-0 right-0 bottom-0 z-10 transform transition-all duration-300 ease-in-out ${
          isMobileMenuOpen ? "h-full" : "h-0"
        }`}
      >
        <div className="container h-full overflow-y-auto bg-general-gray-100">
          <nav className="flex flex-col">
            {menuItems.map((item) => {
              const IconComponent = item.icon;
              return (
                <Link
                  key={item.label}
                  to={item.link}
                  className="flex items-center px-3 py-2 text-base font-medium text-foreground border-b border-general-gray-400 h-16"
                  onClick={(e) => {
                    setIsMobileMenuOpen(false);
                    if (item.onClick) {
                      e.preventDefault();
                      item.onClick();
                    }
                  }}
                >
                  <IconComponent className="h-6 w-6 mr-2.5" />
                  {item.label}
                </Link>
              );
            })}
          </nav>
        </div>
      </div>
      <div className="hidden md:flex">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" size={"small"}>
              <Menu className="h-6 w-6" />
              <span className="sr-only">Open menu</span>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" sideOffset={0} className="w-48 mt-0">
            {menuItems.map((item) => {
              const IconComponent = item.icon;
              return (
                <DropdownMenuItem key={item.label} asChild>
                  <Link to={item.link} className="cursor-pointer flex items-center gap-2" onClick={item.onClick}>
                    <IconComponent className="h-4 w-4" />
                    {item.label}
                  </Link>
                </DropdownMenuItem>
              );
            })}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>

      <div className="md:hidden z-100">
        <Button variant="ghost" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
          {isMobileMenuOpen ? <X className="!h-5 !w-5" /> : <Menu className="!h-5 !w-5" />}
          <span className="sr-only">Toggle menu</span>
        </Button>
      </div>
    </>
  );
}
